import classNames from "classnames";

import isLockerInactive from "@components/Lockers/_lib/isLockerInactive";

const LockerCardName = ({ locker }) => (
  <>
    {locker?.name && (
      <div
        className={classNames("font-medium", {
          "text-[#767676]": isLockerInactive(locker),
        })}
      >
        {locker.name}
      </div>
    )}
  </>
);

export default LockerCardName;
